import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ValueCards from '../components/ValueCards';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import FlavorCircles from '../components/FlavorCircles';
import FunctionalShots from '../components/FunctionalShots';
import ComparisonTable from '../components/ComparisonTable';
import QuickSavingsEstimator from '../components/QuickSavingsEstimator';
import SplitSections from '../components/SplitSections';
import PricingStrip from '../components/PricingStrip';
import CustomerStories from '../components/CustomerStories';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
const HomePage = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-819">
      <SEO title="SmartSoda | Premium Workplace Beverage Solutions | Save 50% on Office Drinks" description="Transform your workplace beverage experience with SmartSoda's sustainable, delicious, and cost-effective solutions. 29+ flavors, 90% plastic reduction, and up to 50% cost savings." keywords="SmartSoda, office beverages, workplace drinks, sustainable beverages, premium drinks, beverage dispenser, cost-effective drinks, eco-friendly beverages" data-id="element-820" />
      <Navbar data-id="element-821" />
      <main className="flex-grow" id="main-content" data-id="element-822">
        <Hero data-id="element-823" />
        <ValueCards data-id="element-824" />
        <SocialProof data-id="element-825" />
        <HowItWorks data-id="element-826" />
        <FlavorCircles data-id="element-827" />
        <FunctionalShots data-id="element-828" />
        <ComparisonTable data-id="element-829" />
        <QuickSavingsEstimator data-id="element-830" />
        <SplitSections data-id="element-831" />
        <PricingStrip data-id="element-832" />
        <CustomerStories data-id="element-833" />
        <FAQ data-id="element-834" />
        <CTASection data-id="element-835" />
      </main>
      <Footer data-id="element-836" />
    </div>;
};
export default HomePage;